/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'

const API_URL_giphy = ENV().REACT_APP_TEST_GIPHY

const initialState = {
  Giphy: {},
}

export const GetAllGiphy: any = createAsyncThunk('GetGiphy', async (data: any) => {
  let finalParam = {...data, api_key: `2iWQtaVG3z7JwH005fbyStWwklkvVi7g`}

  const response = await axios.get(`${API_URL_giphy}trending`, {
    params: finalParam,
  })
  return response.data
})
export const SearchGiphy: any = createAsyncThunk('search/GetGiphy', async (data: any) => {
  let finalParam = {...data, api_key: `W4daFthpti7pgUCghRkNkJC8PeU5xKml`}
  const response = await axios.get(`${API_URL_giphy}search`, {
    params: finalParam,
  })

  return response.data
})
const getAllGiphy = createSlice({
  name: 'GetGiphy',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetAllGiphy.fulfilled, (state, action) => {
      return {...state, Giphy: action?.payload}
    })

    builder.addCase(SearchGiphy.fulfilled, (state, action) => {
      return {...state, Giphy: action?.payload}
    })
  },
})

export default getAllGiphy.reducer

// [GetAllGiphy.pending]: (state) => {
//     console.log('Fetched Pending')
//   },
//   [GetAllGiphy.fulfilled]: (state, {payload}) => {

//     console.log( 'Fetched Success>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>')
//   //   {
//   //     payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
//   //   }
//     return {...state, Giphy: payload}
//   },
//   [GetAllGiphy.rejected]: () => {
//     console.log('Fetched Rejected')
//   },
